import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TrackPageView = () => {
  const location = useLocation();

  useEffect(() => {
    window.gtag('config', 'G-YMQH435FFV', {
      page_path: location.pathname,
    });
  }, [location]);

  return null;
};

export default TrackPageView;
